import { Moment } from 'moment';

import { ItemOrderHistoryBase } from 'app/buffer-graph/models/item-order-history/item-order-history-base';
import {ItemOrderHistoryLine} from "./item-order-history-line";

export class ItemOrderHistory extends ItemOrderHistoryBase<ItemOrderHistory> {
    constructor(
        id: string,
        orderId: number,
        innerOrderId: number,
        date: string,
        planArriveDate: string,
        documentNo: number,
        order: string,
        orderType: string,
        distOrder : number,
        status: number,
        statusDesc: string,
        statusDescStyle: number,
        fulfillment: number,
        fulfillmentDesc: string,
        fulfillmentDescStyle: number,
        arrivalDate: string,
        arrivedQuantity: number,
        supplierCode: string,
        supplierName: string,
        buffer: string,
        safetyStock: string,
        balance: number,
        inTransit: number,
        need: number,
        hasData: string,
        hasMoq: string,
        hasMoa: string,
        extraAttribute: string,
        purchasePrice: number,
        isCwh: boolean,
        crossDock: any) {
        super(
            id,
            orderId,
            innerOrderId,
            date,
            planArriveDate,
            documentNo,
            order,
            orderType,
            distOrder,
            status,
            statusDesc,
            statusDescStyle,
            fulfillment,
            fulfillmentDesc,
            fulfillmentDescStyle,
            arrivalDate,
            arrivedQuantity,
            supplierCode,
            supplierName,
            buffer,
            safetyStock,
            balance,
            inTransit,
            need,
            hasData,
            hasMoq,
            hasMoa,
            extraAttribute,
            purchasePrice,
            isCwh,
            crossDock);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history.ts